import React, { PureComponent } from 'react';
import {
    Text,
    Modal,
    DateInput,
    TextInput,
    Button
} from '@simplybenefits/sb-ui-library';
import Slide from '@mui/material/Slide';
import { connect } from 'react-redux';
import { terminateAccount } from '../../actions/accounts.js';
import * as dates from "@simplybenefits/sb-dates";

class AccountTerminationModal extends PureComponent {
    state = {
        confirmAccountTermination: false,
        allowAccountTermination: false,
        allowAccountTerminationConfirmation: "",
        allowAccountTerminationConfirmationError: "",
        effDate: dates.formatDateForDisplay(this.props.currentAccountMeta.terminationDate, "YYYY/MM/DD") || "",
        effectiveDateError: ""
    };

    _transition = React.forwardRef((props, ref) => <Slide ref={ref} direction="up" {...props} />);

    _closeAccountTerminationModal = () => {
        this.props.toggleAccountTerminationModal();

        this.setState({ confirmAccountTermination: false }); 
    };

    _validateEffDate = (value) => {
        this.setState({
            effectiveDateError: false
        });


        // dates can be future dated but not back dated
        const noFutureDates = false;
        const noPastDates = true;
        let isValidDate = dates.validate(value, noFutureDates, noPastDates);

        // we want to allow the last effective date to be yesterday or today, and previous validation doesnt handle those cases
        const today = dates.getUTC(dates.getLocalDisplay());
        const yesterday = dates.getUTC(dates.getPastDate(false, 1, "days"));

        if (dates.getUTC(value) === today || dates.getUTC(value) === yesterday) {
            isValidDate = false;
        }
        
        if (isValidDate) {
            this.setState({
                effectiveDateError: isValidDate
            });
        }

        this.setState({
            effDate: value
        });
    };

    _setEffectiveDate = () => {
        if (this.state.effectiveDateError) {
            return null;
        }
        
        this.setState({
            allowAccountTermination: true
        });

        return null;
    };

    _terminateAccount = () => {
        if (this.state.allowAccountTerminationConfirmation !== "TERMINATE") {
            this.setState({
                allowAccountTerminationConfirmationError: "Please type TERMINATE in the box above"
            });

            return null;
        }

        this.setState({
            allowAccountTermination: true
        });

        const dateInEpochFormat = dates.getFutureDate(this.state.effDate, 1, "days");
        this.props.dispatch(terminateAccount(this.props.currentAccountMeta.accountID, dateInEpochFormat));
        this.props.toggleAccountTerminationModal();
        return null;
    };

    _goBack = () => {
        this.setState({
            allowAccountTermination: false,
            allowAccountTerminationConfirmationError: false
        });
    };
    
    render() {
        return (
            <Modal
                open={this.props.showAccountTerminationModal}
                transitionComponent={this._transition}
                onClose={ this._closeAccountTerminationModal }
                title={ "Terminate Account" }
                onBack={ this.state.allowAccountTermination && this.state.confirmAccountTermination && this._goBack }
                primaryButton={
                    this.state.allowAccountTermination && this.state.confirmAccountTermination
                        ? {
                            label: "Submit",
                            onClick: this._terminateAccount
                        }
                        : null
                }
                loader={this.props.loader}
            >

                { 
                    !this.state.confirmAccountTermination && !this.props.currentAccountMeta.terminationDate &&
                    <>
                        <Text medium>
                        Are you <strong>sure</strong> you want to terminate this account?
                        </Text>

                        <div style={{ display: "flex", flexDirection: "row", width: "100%", marginTop: "15px" }}>
                            <Button 
                                customStyle={{ width: "48%", marginRight: "4%" }} 
                                color={"error"} 
                                onClick={() => this.setState({ confirmAccountTermination: true })}
                            >
                                YES
                            </Button>
                            <Button 
                                customStyle={{ width: "48%" }} 
                                color={"primary"} 
                                onClick={() => this.props.toggleAccountTerminationModal()}
                            >
                                NO
                            </Button>
                        </div>
                    </>
                }

                { // if the agent is trying to change the date of the pending termination, the old one must be deleted first
                    this.props.currentAccountMeta.terminationDate ?

                        <Text medium>
                            To change the date of this pending termination, first delete the pending termination from the Pending Changes tile.
                        </Text>
                        :
            
                        (this.state.confirmAccountTermination && !this.state.allowAccountTermination) &&
                   
                    <>
                        <Text medium>
                            Please provide the <strong>last effective date of coverage</strong> for this account. This can be backdated one day for the termination to happen immediately:
                        </Text>

                        <DateInput
                            label="Effective Date"
                            value={this.state.effDate}
                            onBlur={ (e) => this._validateEffDate(e.target.value) }
                            error={Boolean(this.state.effectiveDateError)}
                            helperText={this.state.effectiveDateError}
                            fullWidth
                            required
                        />

                        <Button onClick={ this._setEffectiveDate } color="primary" customStyle={{ width: "100%", marginTop: "15px" }}>
                            Proceed to next step
                        </Button>
                    </>

                }

                {
                    
                    this.state.allowAccountTermination && this.state.confirmAccountTermination &&

                    <>
                        <Text medium>
                            The last <strong>effective date of coverage</strong> for this account will be:
                        </Text>

                        <Text medium bold customStyle={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                            { `${ dates.formatDateForDisplay(this.state.effDate) }` }
                        </Text>

                        <Text medium>
                            The account will be terminated on: 
                        </Text>

                        <Text medium bold customStyle={{ textAlign: "center", marginTop: 5, marginBottom: 5 }}>
                            { `${ dates.getFutureDate(this.state.effDate, 1, "days", "ll") }` } 
                        </Text>

                        <Text medium>
                            To edit this date, press the back arrow to return to the previous screen.
                        </Text>

                        <br/>

                        <Text medium>
                            Terminating this account will remove all data associated with it. This action cannot be undone. If you are sure you want to terminate this account, please type the word "TERMINATE" in the box below. 
                        </Text>

                        <TextInput
                            label="Confirm Account Termination "
                            value={this.state.allowAccountTerminationConfirmation}
                            onChange={(e) => this.setState({ allowAccountTerminationConfirmation: e.target.value })}
                            error={Boolean(this.state.allowAccountTerminationConfirmationError)}
                            helperText={this.state.allowAccountTerminationConfirmationError}
                            fullWidth
                            required
                        />

                    </>
                }

            </Modal>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    currentAccountMeta: state.accounts.currentAccount.meta
});

export default connect(mapStateToProps)(AccountTerminationModal);